import type { OnDestroy, OnInit } from '@angular/core';
import { Directive, inject } from '@angular/core';

import type { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';
import type { RecaptchaErrorParameters } from 'ng-recaptcha';

import { RecaptchaWidgetRegistry } from '@valk-nx/services/recaptcha/src/lib/recaptcha-widget-registry.service';

@Directive()
export abstract class RecaptchaV2BaseComponent
	extends FieldType<FieldTypeConfig>
	implements OnInit, OnDestroy
{
	private readonly registry = inject(RecaptchaWidgetRegistry);
	private unregister?: () => void;

	ngOnInit(): void {
		this.unregister = this.registry.register({
			getToken: () => this.formControl.value,
			// Clearing the control makes ng-recaptcha's value accessor reset
			// the widget, forcing the user to solve it again.
			reset: () => this.formControl.reset(),
		});
	}

	ngOnDestroy(): void {
		this.unregister?.();
	}

	onError(errorDetails: RecaptchaErrorParameters): void {
		console.warn(`reCAPTCHA error: ${errorDetails}`);
	}
}
